var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloggerFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.25H10C9.59 13.25 9.25 13.59 9.25 14C9.25 14.41 9.59 14.75 10 14.75H14C14.41 14.75 14.75 14.41 14.75 14C14.75 13.59 14.41 13.25 14 13.25Z",
    fill: "#246BFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.75H12C12.41 10.75 12.75 10.41 12.75 10C12.75 9.59 12.41 9.25 12 9.25H10C9.59 9.25 9.25 9.59 9.25 10C9.25 10.41 9.59 10.75 10 10.75Z",
    fill: "#246BFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1878 2H7.81781C4.17781 2 2.00781 4.17 2.00781 7.81V16.18C2.00781 19.82 4.17781 21.99 7.81781 21.99H16.1878C19.8278 21.99 21.9978 19.82 21.9978 16.18V7.81C21.9978 4.17 19.8278 2 16.1878 2ZM17.9978 15C17.9978 17 16.9978 18 14.9978 18H8.9978C6.9978 18 5.9978 17 5.9978 15V9C5.9978 7 6.9978 6 8.9978 6H12.9978C14.9978 6 15.9978 7 15.9978 9V10C15.9978 10.55 16.4478 11 16.9978 11C17.5478 11 17.9978 11.45 17.9978 12V15Z",
    fill: "#246BFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloggerFilled);
export default __webpack_public_path__ + "static/media/blogger-filled.80cbec2c3f50c3c5c0362225eefd4cc5.svg";
export { ForwardRef as ReactComponent };